import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize
} from '@material-ui/core';
import {Controller, SubmitHandler, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {updateMessageEventTypeStatus} from '@shared/services/MessageService';
import {ReminderWorkFlowStatusTypes} from '@shared/constants/Mapping';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import './MarkAsDoneDialog.scss';

interface MarkAsDoneDialogProps {
  open: boolean;
  onClose: (response: 'confirm' | 'cancel') => void;
  clinicGroupId: number;
  clinicId: number;
  messageId: number;
  notes: string;
}
interface MarkAsDoneFormFields {
  notes: string;
}
const MarkAsDoneDialog = (props: MarkAsDoneDialogProps): JSX.Element => {
  const {
    open,
    onClose,
    clinicGroupId,
    clinicId,
    messageId,
    notes: defaultNote
  } = props;
  const {
    control,
    handleSubmit,
    formState: {isSubmitting}
  } = useForm<MarkAsDoneFormFields>({
    mode: 'all',
    defaultValues: {
      notes: defaultNote
    }
  });
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const handleFormSubmit: SubmitHandler<MarkAsDoneFormFields> = async data => {
    try {
      const res = await updateMessageEventTypeStatus(
        clinicGroupId,
        clinicId,
        messageId,
        ReminderWorkFlowStatusTypes.COMPLETED,
        data.notes
      );
      enqueueSnackbar(res.message, SnackBarConfig('s'));
      onClose('confirm');
    } catch (error: any) {
      enqueueSnackbar(
        error?.message || t('ERROR WHILE FETCHING INVOICE SERVICE DATA'),
        SnackBarConfig('e')
      );
    }
  };
  return (
    <Dialog
      maxWidth={'md'}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={() => onClose('cancel')}
      className="mark-as-done-dialog">
      <DialogTitle disableTypography>
        {t('INCOMING_SMS.MARK_AS_DONE_DIALOG.TITLE')}
      </DialogTitle>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <DialogContent dividers>
          <Controller
            name="notes"
            control={control}
            render={inputProps => (
              <div className="notes-input-wrapper">
                <p>{t('INCOMING_SMS.MARK_AS_DONE_DIALOG.NOTES')}</p>
                <TextareaAutosize
                  rowsMax={10}
                  rows={4}
                  aria-label="notes"
                  placeholder={t(
                    'INCOMING_SMS.MARK_AS_DONE_DIALOG.NOTES_PLACEHOLDER'
                  )}
                  {...inputProps}
                  className="app-text-area text-area-auto-size"
                />
              </div>
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isSubmitting}
            onClick={() => onClose('cancel')}
            variant="text"
            size={'small'}>
            {t('COMMON.CANCEL')}
          </Button>
          <Button
            disabled={isSubmitting}
            variant="contained"
            type="submit"
            size={'small'}
            color="primary">
            {t('COMMON.SUBMIT')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MarkAsDoneDialog;
